import React, { Component } from 'react';
import SharePane from './SharePane';
import ShareIcon from '../assets/imgs/share_black.svg';
import CopyText from './CopyText';
type Props = {
	selectedBotid: string;
	selectedBaseURL: string;
	tenantId: number;
	toasterNotify: Function;
};
type State = {
	isSharePaneOpen: boolean;
};
export default class TeamTab extends Component<Props, State> {
	private myRef: React.RefObject<HTMLInputElement>;
	constructor(props: Props) {
		super(props);
		this.state = {
			isSharePaneOpen: false,
		};
		this.myRef = React.createRef();
		this.redirectToExternalBot = this.redirectToExternalBot.bind(this);
		this.toggleSharePane = this.toggleSharePane.bind(this);
		this.handleClickOutside = this.handleClickOutside.bind(this);
	}
	componentDidMount() {
		document.addEventListener('click', this.handleClickOutside);
	}
	componentWillUnmount() {
		document.removeEventListener('click', this.handleClickOutside);
	}
	redirectToExternalBot() {
		var Environment = 'AwarePROD';
		if (this.props.selectedBaseURL === 'https://awareuat.senseforth.com') {
			Environment = 'AwarePreProdOld';
		} else if (
			this.props.selectedBaseURL === 'https://aware-preprod.senseforth.com'
		) {
			Environment = 'AwarePreProdNew';
		} else if (
			this.props.selectedBaseURL === 'https://flyfish.senseforth.com'
		) {
			Environment = 'Flyfish';
		} else if (
			this.props.selectedBaseURL === 'https://flyfishuat.senseforth.com'
		) {
			Environment = 'FlyfishUAT';
		}
		window.open(
			`/customer2/chatsdk.html?botID=` +
				encodeURIComponent(this.props.selectedBotid) +
				`&env=` +
				Environment
		);
	}
	toggleSharePane = () => {
		// if (this.props.isOverlayVisible) this.props.toggleOverlay();
		// if (!this.props.isChatBodyVisible) this.props.toggleChatBody();
		this.setState((state) => ({ isSharePaneOpen: !state.isSharePaneOpen }));
	};

	handleClickOutside = (event: any) => {
		if (this.myRef.current && !this.myRef.current.contains(event.target)) {
			this.setState({
				isSharePaneOpen: false,
			});
		}
	};
	render() {
		return (
			<div className='selected-channel-container-component'>
				Follow the following steps to connect your bot to any website
				<div className='web-steps-wrapper'>
					<ol>
						<li>
							Make sure that you have the desired version of the bot deployed in
							A.ware. You can switch to a different version even after you have
							connected your bot with a channel.
						</li>
						<li>
							Make sure that the bot access is configured to be public in
							A.ware.
						</li>
						<li>
							To test the Hybrid Chat enabled bot without adding it to a
							website, use the following link.
							{/* <div
                className={`header-btns share-link-wrapper ${
                  this.state.isSharePaneOpen ? 'hover' : ''
                }`}
                onClick={this.toggleSharePane}
                ref={this.myRef}>
                <img src={ShareIcon} alt='ShareIcon' className='share-icon-img' />
                {this.state.isSharePaneOpen ? ( */}
							{/* <div className='share-pane-arrow' /> */}
							<SharePane
								// isBotDeployed={this.props.data.isBotDeployed}
								encryptedBotId={this.props.selectedBotid}
								redirectToExternalBot={this.redirectToExternalBot}
								selectedBaseURL={this.props.selectedBaseURL}
							/>
							{/* ) : null}
              </div> */}
						</li>
						<li>
							To add the Hybrid Chat enabled bot to a website, add the following
							code under the head tag of the HTML code of the website.
							<div style={{ display: 'flex' }}>
								<code id='pre'>
									<pre>{`   <script>
      function initSenseforthChatSDK() {
        var senseforthSDKconfig = {
          botID: "${decodeURIComponent(this.props.selectedBotid)}",
          SF_BASE_URL: "${this.props.selectedBaseURL}",
          SF_CHAT_URL: "${window.origin}",
          version: 'prod'
        };
        var sdk = new SenseforthChatSDK(senseforthSDKconfig);
        sdk.init();
      }
  </script>
  <script src="${
		window.origin
	}/customer2/chatsdk/v1/SenseforthChatSDKLoader.js"></script>`}</pre>
								</code>

								<div className='copy-text-wrapper'>
									<CopyText idToCopy='pre' />
								</div>
							</div>
						</li>
					</ol>
				</div>
			</div>
		);
	}
}
